// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { GeneralKind } from "../../../../define/GeneralKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import UserDataManage from "../../../model/UserDataManage";
import ShipListLayer from "./ShipListLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ShipItem extends BaseComponent {

	@property({ type: cc.Node, displayName:'' })
	nodeOwnCount: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelHint: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeOwn: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	btnBuy: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelStore: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelOwnCount: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelPrice: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelTitle: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	itemIcon: cc.Sprite = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    private shipId: string = null;
    private _parent: ShipListLayer = null;
    private csvInfo: any = null;

    private storeCount = 0;

    start () {
        this.refreshUI();
    }

    setData(
        _parent: ShipListLayer
        , shipId: string
    ) {
        this.shipId = shipId;
        this._parent = _parent;
        if (this.isInit()) {
            this.refreshUI();
        }
    }

    refreshUI() {
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.SHIP, this.shipId);
        let shipData = UserDataManage.instance.shipDataManage.shipData;

        if (!this.csvInfo) {
            console.error(`未找到数据 SHIP id = ` + this.shipId);
            return;
        }

        let data = shipData.lists.get(this.shipId);

        let is_open = this.csvInfo.is_open;
        if (is_open == GeneralKind.EnableState.ENABLED) {
            if (!data) {
                data = shipData.createItem(this.shipId);
                data.price = Number(this.csvInfo.price);
                data.store = Number(this.csvInfo.repertory);
                shipData.saveLocalData();
            }
        }

        this.labelTitle.string = this.csvInfo.name;
        if (!data) {
            this.btnBuy.active = false;
            this.nodeOwn.active = false;
            this.labelHint.node.active = true;

            this.nodeOwnCount.active = false;

            this.labelPrice.string = '???';
            this.labelStore.string = '???';
        } else {
            this.labelHint.node.active = false;
            this.nodeOwnCount.active = true;
            this.labelOwnCount.string = data_control.getNumberFormat(data.ownCount);
            this.labelPrice.string = data_control.getNumberFormat(data.price);
            this.labelStore.string = data_control.getNumberFormat(data.store);

            if (data.ownCount > 0) {
                this.btnBuy.active = false;
                this.nodeOwn.active = true;
            } else {
                this.btnBuy.active = true;
                this.nodeOwn.active = false;
            }
        }
        this.storeCount = data && data.store || 0;

        this.refreshIcon();
    }

    refreshIcon() {
        this.itemIcon.node.active = false;

        let path = 'assets/ship/items/' + this.csvInfo.icon;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.investStockGameBundle).load(path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.itemIcon.node.active = true;
                    this.itemIcon.spriteFrame = imgs;
                }
            }
        );
    }

    onClickBuy() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if (this.storeCount <= 0) {
            O1HD.getModules().uiControlModule.showMessageBox('库存不足');
            return;
        }
        this.openBuyLayer(false);
    }

    onClickAgainBuy() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        if (this.storeCount <= 0) {
            O1HD.getModules().uiControlModule.showMessageBox('库存不足');
            return;
        }
        this.openBuyLayer(false);
    }

    onClickSells() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.openBuyLayer(true);
    }

    openBuyLayer(bSell: boolean) {
        O1HD.getModules().uiControlModule.showLoading();
        utilsView.openPopupLayer(
            'prefab/ship/ShipSelectBuyLayer'
            , BUNDLE_SMALL_NAME.investStockGameBundle
            , null
            , {
                shipId: this.shipId
                , bSell: bSell
                , icon: this.csvInfo.icon
                , parent: this
            }
            , null
            , null
            , false
        );
    }

    // update (dt) {}
}
